
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bundesliga/finals",
      function () {
        return require("private-next-pages/bundesliga/finals/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bundesliga/finals"])
      });
    }
  